export default {
  name: 'ConfigNavbar',
  computed: {
    user_name() {
      return this.$store.getters.currentLeadName || 'Workspace User';
    },
    role() {
      return this.$store.getters.currentRole || '';
    },
    role_label() {
      return this.role || 'System workspace';
    },
    user_initials() {
      return this.user_name
        .split(' ')
        .filter(Boolean)
        .map((part) => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
    }
  }
}
